module.exports = __webpack_public_path__ + "22483421ad2a615bae163a8dbf1cdbc3.png";